import { useMemo } from "react";
import { generateStoragePath } from "../utils/generateStoragePath";

export const useGeneratedPathForFileUpload = (orderId: string) => {
  const generatedPath = useMemo(() => {
    return generateStoragePath(orderId);
  }, [orderId]);
  return generatedPath;
};
